import React from 'react'
import BaseIcon from 'react-icon-base'

const MA = props => (
  <BaseIcon viewBox="0 0 900 600" width={21} height={15} {...props}>
    <title>Flag of Morocco</title>
    <rect width="900" height="600" fill="#c1272d" />
    <path
      d="m449.99991,224.31497-44.4674,136.87006 116.40181-84.55895H378.06451l116.4028,84.55895z"
      fill="none"
      stroke="#006233"
      strokeWidth="14.62993431"
    />
  </BaseIcon>
)

export default MA
